<script lang="ts">
  import { fontSize } from '../stores';

  // 顯示動態時間（每秒更新）
  function onMountHeader(node: HTMLElement) {
    const timeEl = node.querySelector('#header-time') as HTMLElement | null;
    if (!timeEl) return { destroy: () => {} };

    const fmt = () => new Date().toLocaleString('zh-TW', {hour12: false});
    const tick = () => { timeEl.textContent = fmt(); };

    tick();
    const id = setInterval(tick, 1000);
    return { destroy: () => clearInterval(id) };
  }
</script>

<header use:onMountHeader class="bg-linear-to-r from-blue-700 to-blue-900 text-white shadow-lg">
  <div class="container mx-auto max-w-4xl flex items-center justify-between px-4 py-2 sm:py-3">
    <div class="flex items-center gap-3">
      <h1 class="text-xl sm:text-2xl font-black leading-tight">
        物管檢查清單
      </h1>
      <span class="hidden sm:inline text-blue-100 text-sm font-semibold">管理系統 v2.0</span>
    </div>

    <div class="text-right">
      <div class="flex items-center gap-3">
        <div class="text-sm sm:text-base font-medium" id="header-time">--:--:--</div>
            <label for="font-size-select" class="sr-only">字型大小</label>
            <select
              id="font-size-select"
              value={$fontSize}
              on:change={(e) => fontSize.set((e.target as HTMLSelectElement).value as 'small' | 'medium' | 'large')}
              class="rounded-md bg-white text-blue-800 px-2 py-1 text-sm"
              title="字型大小"
            >
              <option value="small">小</option>
              <option value="medium">中</option>
              <option value="large">大</option>
            </select>
            <button
          on:click={() => {
            if (!confirm('確定要清除本系統的暫存資料（localStorage）並重新載入頁面嗎？')) return;
            try {
              localStorage.removeItem('dmy_session');
              localStorage.removeItem('dmy_records');
              localStorage.removeItem('dmy_step');
              localStorage.removeItem('dmy_checklist_id');
            } catch (e) {
              console.error('清除 localStorage 時發生錯誤', e);
            }
            location.reload();
          }}
          class="px-3 py-1 bg-white text-blue-800 rounded-md font-semibold text-sm hover:bg-gray-100"
          title="清除本地儲存並重新載入"
        >
          重設
        </button>
      </div>
    </div>
  </div>


</header>
